import { render } from "./WebShopList.vue?vue&type=template&id=a915b7f6&scoped=true&ts=true"
import script from "./WebShopList.vue?vue&type=script&lang=ts"
export * from "./WebShopList.vue?vue&type=script&lang=ts"

import "./WebShopList.vue?vue&type=style&index=0&id=a915b7f6&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a915b7f6"]])

export default __exports__